export default "__VITE_ASSET__CrC6PCdy__"